import { render } from "./ChatFormBtns.vue?vue&type=template&id=46c5923c&scoped=true"
import script from "./ChatFormBtns.vue?vue&type=script&lang=js"
export * from "./ChatFormBtns.vue?vue&type=script&lang=js"

import "./ChatFormBtns.vue?vue&type=style&index=0&id=46c5923c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c5923c"],['__file',"webpack-assets/vue/templates/chat/parts/ChatFormBtns.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c5923c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c5923c', __exports__)) {
    api.reload('46c5923c', __exports__)
  }
  
  module.hot.accept("./ChatFormBtns.vue?vue&type=template&id=46c5923c&scoped=true", () => {
    api.rerender('46c5923c', render)
  })

}


export default __exports__